<ul class="calculator">

  <nav class="lib-nav">
    <h6>How do we compare</h6>
    <div class="lib-badge">
      <span>INDICATIVE ONLY</span>
    </div>
    <span class="lib-spacer"></span>
  </nav>

  <li>
    <ol class="lib-elevation-0">
      <li>
        <p class="lib-legend">Proportunity Loan</p>
        <!-- <p class="lib-legend">15 - 25%</p> -->
      </li>
      <li>
        <h6>{{comparison?.with_proportunity?.loan | shortNumber}}</h6>
        <p class="lib-legend">{{comparison?.with_proportunity?.loan_percent | percent}}</p>
      </li>
      <li>
        <p class="lib-legend">VS</p>
        <p class="lib-legend">Bank&nbsp;only</p>
      </li>
    </ol>
  </li>

  <li>
    <ol class="lib-elevation-0">
      <li>
        <p class="lib-legend">Mortgage</p>
      </li>
      <li>
        <h6>{{comparison?.with_proportunity?.mortgage | shortNumber}}</h6>
        <p class="lib-legend">{{comparison?.with_proportunity?.mortgage_percent | percent}}</p>
      </li>
      <li>
        <h6>{{comparison?.without_proportunity?.mortgage | shortNumber}}</h6>
        <p class="lib-legend">{{comparison?.without_proportunity?.mortgage_percent | percent}}</p>
      </li>
    </ol>
  </li>

  <li>
    <ol class="lib-elevation-0">
      <li>
        <p class="lib-legend">Deposit</p>
      </li>
      <li>
        <h6>{{comparison?.with_proportunity?.deposit | shortNumber}}</h6>
        <p class="lib-legend">{{comparison?.with_proportunity?.deposit_percent | percent}}</p>
      </li>
      <li>
        <h6>{{comparison?.without_proportunity?.deposit | shortNumber}}</h6>
        <p class="lib-legend">{{comparison?.without_proportunity?.deposit_percent | percent}}</p>
      </li>
    </ol>
  </li>

  <li>
    <ol class="lib-elevation-0">
      <li>
        <p class="lib-legend">Per month<sup>†</sup></p>
        <p class="lib-legend">Proportunity + Bank</p>
      </li>
      <li>
        <h6>£{{comparison?.with_proportunity?.per_month?.total}}&nbsp;</h6>
        <p class="lib-legend">
          (£{{comparison?.with_proportunity?.per_month?.proportunity }}<!-- <span>Proportunity</span> -->
          &nbsp;+&nbsp;
          £{{comparison?.with_proportunity?.per_month?.mortgage }}<!-- <span>Mortgage</span> -->)
        </p>
        <!-- <p class="lib-legend">£{{comparison?.with_proportunity?.per_month?.mortgage }}</p> -->
      </li>
      <li>
        <h6>£{{comparison?.without_proportunity?.per_month?.total}}</h6>
        <p class="lib-legend">Bank only</p>
      </li>
    </ol>
  </li>

  <li>
    <ol>
      <li>
        <p class="lib-legend">Min household income</p>
      </li>
      <li>
        <h6>{{comparison?.with_proportunity?.income_min | shortNumber}}</h6>
      </li>
      <li>
        <h6>{{comparison?.without_proportunity?.income_min | shortNumber}}</h6>
      </li>
    </ol>
  </li>

  <span class="lib-spacer-fixed"></span>

</ul>

<!-- <app-representative-example></app-representative-example> -->
